import CalendarBindings from './CalendarBindings.js';
import pickmeup from './pickmeup.js';
import moment from 'moment';


export default new class Calendar {
    constructor() {
        this.calendarClassname = '_js-calendar-two';
        this.calendarFieldClassname = 'calendar__field';
        this.productCalendarOverlay = 'js-calendar-overlay';

        this.overlayAmnimationSpeed = 450;

        this.currentDate = new Date($('.calendar-details__summary').data('date'));
        this.tomorrowDate = new Date(moment().add(1, 'days').format('YYYY-MM-DD'));

        this.calendars = [];

        this.initPickmeup();
        this.fillFields();
        this.fieldCheck();
        new CalendarBindings(this);
    }

    initPickmeup() {
        if ($(`.${this.calendarClassname}`).length) {
            let today = new Date(),
                dateYesterday = new Date();

            dateYesterday.setDate(dateYesterday.getDate() - 1);
            var _this = this;



            for(var i = 0; i < $(`.${_this.calendarClassname}`).length; i++) {
                var dateInitVal;
                if ( $('.page-cart').length ) {
                    var dateInitValElem = $('._js-calendar-two')[i].closest('article.cart-item');
                    var dateInitValStart = new Date(dateInitValElem.dataset.offerStart);
                    dateInitVal = [dateInitValStart, new Date(new Date(dateInitValElem.dataset.offerStart).setDate(new Date(dateInitValElem.dataset.offerStart).getDate() + +dateInitValElem.dataset.offerPeriod))];
                } else {
                    dateInitVal = [_this.currentDate, _this.tomorrowDate];
                }

                _this.calendars.push(pickmeup($('._js-calendar-two')[i], {
                    date: dateInitVal,
                    flat: true,
                    mode: 'range',
                    calendars: 2,
                    field_range: 2,
                    select_year: false,
                    format: 'Y-m-d',
                    min: today,
                    prev: '<img src=\'/themes/arenda/assets/img/arrow-month.svg\'/>',
                    next: '<img src=\'/themes/arenda/assets/img/arrow-month.svg\'/>',
                    render: (date) => {
                        if (date < dateYesterday) {
                            return { disabled: true, class_name: 'date-in-past' };
                        }
                        return {};
                    }
                }));
                //this.calendars[0].next();
                _this.fillFields(_this.currentDate);
            }


        }
    }

    // createCalendar(calendarClassname) {
    //     let dateYesterday = new Date();
    //     dateYesterday.setDate(this.currentDate.getDate() - 1);
    //
    //     $(`.${calendarClassname}`).each((i, element) => {
    //
    //         pickmeup(element, {
    //             date: this.currentDate,
    //             flat: true,
    //             mode: 'range',
    //             calendars: 2,
    //             field_range: 2,
    //             select_year: false,
    //             format: 'Y-m-d',
    //             prev: '<img src=\'/themes/arenda/assets/img/arrow-month.svg\'/>',
    //             next: '<img src=\'/themes/arenda/assets/img/arrow-month.svg\'/>',
    //             render: (date) => {
    //                 if (date < dateYesterday) {
    //                     return {disabled: true, class_name: 'date-in-past'};
    //                 }
    //                 return {};
    //             }
    //         }).next();
    //         this.fillFields(this.currentDate);
    //         this.fieldCheck();
    //     });
    //
    // }

    fillFields(now) {
        let fields = $('.' + this.calendarClassname).find('.' + this.calendarFieldClassname);
        if (fields.length == 2) {
            fields.eq(0).val(pickmeup(`.${this.calendarClassname}`).get_date(true)[0]);
            fields.eq(1).val(pickmeup(`.${this.calendarClassname}`).get_date(true)[1]);
        }
    }

    fieldCheck() {
        $(`.${this.calendarClassname} input`).on('change', (e) => {
            let $target = $(e.target).closest('.calendar__footer').find('.' + this.calendarFieldClassname),
                dateArray = [$target.eq(0).val(), $target.eq(1).val()];

            pickmeup(`.${this.calendarClassname}`).set_date(dateArray);
        });
    }

    /**
     * Show/hide body overlay
     *
     * @param isOverlaySeen - boolean, is overlay should be seen
     */
    toggleCalendarOverlay (isOverlaySeen) {
        let $body = $('body');

        if (isOverlaySeen) {
            //add and show calendar overlay
            $body.append(`<div style="display: none" class="calendar__document-overlay ${this.productCalendarOverlay}"></div>`);
            $(`.${this.productCalendarOverlay}`).fadeIn(this.overlayAmnimationSpeed);
        } else {
            //hide and remove calendar overlay
            $(`.${this.productCalendarOverlay}`).fadeOut(this.overlayAmnimationSpeed);
            setTimeout(() => {
                $(`.${this.productCalendarOverlay}`).remove();
            }, 300);
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/calendar/Calendar.js